import React from 'react';
// React 19 Migration: Using default parameters instead of defaultProps
const PageContent = ({ className = '', children, withHeader = true }) => {
  return (
    <>
      <div
        id="app-content"
        className={`scrollable ${!withHeader ? 'scrollable--website' : ''}`}
      >
        <div className={`content ${className}`}>{children}</div>
      </div>
    </>
  );
};

export default PageContent;
